// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--l-J5n";
export var container = "footer-module--container--2s0h5";
export var title = "footer-module--title--WRYCl";
export var association = "footer-module--association--UvJBm";
export var horaire = "footer-module--horaire--1CdtV";
export var adresse = "footer-module--adresse--U2Yg4";